import { render, staticRenderFns } from "./headerNativation.vue?vue&type=template&id=52cc08c2&scoped=true"
import script from "./headerNativation.vue?vue&type=script&lang=js"
export * from "./headerNativation.vue?vue&type=script&lang=js"
import style0 from "./headerNativation.vue?vue&type=style&index=0&id=52cc08c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cc08c2",
  null
  
)

export default component.exports